export default "__VITE_ASSET__954bd829__"